import React, {
    PropsWithChildren,
    ReactElement,
    Fragment,
    useContext,
} from 'react';
import Head from 'next/head';

import { AccountHeader } from '@pb/shared/ui/organisms/account-header';
import {
    accountNavigationMenuItems,
    lppNavigationMenuItems,
} from '@pb/configuration';
import { EnvironmentContext } from '../../../context';
import { TProperties } from './layout.types';
import { StyledWrapper, StyledContent, StyledMain } from './layout.styled';

export function Layout({
    pageTitle,
    children,
    isCustomer = true,
}: PropsWithChildren<TProperties>): ReactElement {
    const { baseUrl, apiBaseUrl } = useContext(EnvironmentContext);
    return (
        <Fragment>
            <Head>
                <title>{pageTitle}</title>
            </Head>
            <StyledWrapper data-testid="layout">
                <AccountHeader
                    navigationMenuItems={
                        isCustomer
                            ? accountNavigationMenuItems
                            : lppNavigationMenuItems
                    }
                    isCustomer={isCustomer}
                    baseUrl={baseUrl}
                    apiBaseUrl={apiBaseUrl}
                />
                <StyledMain id="main">
                    <StyledContent>{children}</StyledContent>
                </StyledMain>
            </StyledWrapper>
        </Fragment>
    );
}
